export default {"src":"/_next/static/media/fujifilm.7e340bb7.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};